import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { BottomSheet } from "../bottomSheet/BottomSheet"
import './SelectBox.css'

export interface SelectBoxItem {
    name: string,
    value: string,
}

interface SelectBoxProps {
    items: SelectBoxItem[]
    onSelect: (item: SelectBoxItem) => void;
    selectedItem? : SelectBoxItem
}
export interface SelectBoxRef {
    open: () => void
    close: () => void
    getValue: () => string
}

export const SelectBox = forwardRef<SelectBoxRef, SelectBoxProps>(
    ({items, onSelect, selectedItem}, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [_selectedItem, setSelectedItem] = useState<SelectBoxItem | undefined>(selectedItem ?? undefined);

    const Item = ({item} : {item: SelectBoxItem}) => {
        return (
            <div
                className="select-box-item"
                onClick={() => {
                    onSelect(item); setSelectedItem(item)
                }}
            >
                <span className={`select-box-item-text ${_selectedItem?.value === item.value ? "selected" : ""}`}>
                    {item.name}
                </span>
            </div>
        )
    }

    useImperativeHandle(ref, () => ({
        open: () => {
            setIsOpen(true);
        },
        close: () => {
            setIsOpen(false);
        },
        getValue: () => {
            return _selectedItem?.value ?? "";
        }
    }))

    return (
        <>
            <BottomSheet
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div className="select-box-container">
                    {items.map((item, index) => (
                        <Item key={index} item={item}/>
                    ))}
                </div>
            </BottomSheet>
        </>
    )
});